module.exports = __webpack_public_path__ + "c6f90edd8a64470da0ac78ab1ea8c6b7.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/LeagueGothic/leaguegothic-condensed-regular-webfont.ttf
// module id = 358
// module chunks = 0